import React from 'react';


const TermsAndConditions = () => {
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h1>Terms and Conditions</h1>

      <p><strong>Effective Date:</strong> July 1, 2025</p>

      <p>
        Welcome to AMESABU. By accessing or using our website
        (<a href="https://www.amesabu.com" target="_blank" rel="noopener noreferrer">https://www.amesabu.com</a>), mobile application, or any related services,
        you agree to be bound by the following Terms and Conditions. If you do not
        agree to these terms, please do not use our services.
      </p>

      <h2>1. Use of the Platform</h2>
      <ul>
        <li>You must be at least 18 years old or have parental/guardian consent to use AMESABU.</li>
        <li>You agree to use the platform for lawful purposes only.</li>
        <li>Unauthorized use of the platform may give rise to a claim for damages and/or be a criminal offence.</li>
      </ul>

      <h2>2. User Accounts</h2>
      <ul>
        <li>To access certain services, you may need to register and create an account.</li>
        <li>You are responsible for maintaining the confidentiality of your account information.</li>
        <li>You agree to provide accurate and complete information during registration.</li>
      </ul>

      <h2>3. Content Ownership</h2>
      <ul>
        <li>All content on AMESABU, including videos, graphics, text, logos, and code, is the property of AMESABU or its licensors.</li>
        <li>You may not copy, reproduce, distribute, or create derivative works without written permission.</li>
      </ul>

      <h2>4. User-Generated Content</h2>
      <ul>
        <li>If you submit any content (comments, feedback, etc.), you grant AMESABU a non-exclusive, royalty-free license to use, display, and distribute it.</li>
        <li>You agree not to upload content that is unlawful, offensive, or infringes on others' rights.</li>
      </ul>

      <h2>5. Privacy</h2>
      <p>
        Your use of AMESABU is subject to our{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, which explains how we collect and handle your data.
      </p>

      <h2>6. Termination</h2>
      <ul>
        <li>AMESABU may suspend or terminate your access to the platform if you violate these Terms.</li>
        <li>
          You may also delete your account at any time by contacting us at{' '}
          <a href="mailto:amesabuofc@gmail.com">amesabuofc@gmail.com</a>.
        </li>
      </ul>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        AMESABU provides the platform "as is" and does not guarantee uninterrupted
        or error-free service. We disclaim all warranties to the fullest extent
        permitted by law.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        AMESABU will not be liable for any direct, indirect, incidental, or
        consequential damages arising from your use of the platform.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These Terms shall be governed by the laws of India. Any disputes will be
        subject to the jurisdiction of courts in Bhubaneswar, Odisha.
      </p>

      <h2>10. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the platform
        indicates your acceptance of the modified Terms.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions or concerns, please contact us at:{' '}
        <a href="mailto:amesabuofc@gmail.com">amesabuofc@gmail.com</a>
      </p>
    </div>

  );
};

export default TermsAndConditions;
